<template>
  <div class="dashboard-layout">
    <aside class="sidebar">
      <div class="top-icons">
      
          <router-link  class="icon-btn" to="/">
          <img :src="logoImg" class="brand-logo" />
        
      </router-link>
        
      </div>

      <div class="bottom-icons">
       
        <div class="avatar">
          {{ userInitials }}
        </div>
      </div>
    </aside>

    <div class="main-area">
      <header class="app-header">
        <div class="left">
          <h2>Omnichannel</h2>
        </div>

        <div class="right">
          <!-- <button class="workflow-btn" @click="createNew">
            <span class="plus">＋</span>
            Create New Workflow
          </button> -->

          <div class="profile">
            <div class="profile-badge">{{ userInitials }}</div>
            <div class="profile-info">
              <div class="name">{{ user?.username || "User" }}</div>
              <div class="email">{{ user?.role || "-" }}</div>
            </div>
          </div>

          <button class="logout-btn" @click="logout" >↪</button>
        </div>
      </header>

      <BroadcastCampaignReport/>
    </div>

    <!-- Edit/Create Modal -->
    <div v-if="showEditor" class="modal-overlay" @click.self="closeEditor">
      <div class="modal">
        <div class="modal-head">
          <h2>{{ activeId === -1 ? "Create Flow" : "Edit Flow" }}</h2>
          <button class="close-btn" @click="closeEditor">×</button>
        </div>

        <div class="modal-body">
          <div class="form-grid">
            <div class="form-group">
              <label>Flow Name</label>
              <input v-model="form.name" type="text" placeholder="Enter flow name" />
            </div>

            <div class="form-group">
              <label>Start Step</label>
              <input v-model="form.start" type="text" placeholder="welcome" />
            </div>

            <div class="form-group">
              <label>Trigger Words</label>
              <input v-model="form.trigger_words" type="text" placeholder="Trigger Words" />
            </div>

            <div class="form-group">
              <label>Status</label>
              <select v-model="form.is_active">
                <option :value="0">Draft</option>
                <option :value="1">Published</option>
              </select>
            </div>
          </div>

          <div class="steps-header">
            <h3>Steps</h3>
            <button class="small-btn" @click="addStep">+ Add Step</button>
          </div>

          <div class="steps-list">
            <div
              v-for="(step, stepId) in form.steps"
              :key="stepId"
              class="step-card"
            >
              <div class="step-card-head">
                <div class="step-id">{{ stepId }}</div>
                <button class="remove-btn" @click="removeStep(stepId)">Remove</button>
              </div>

              <div class="form-grid">
                <div class="form-group">
                  <label>Type</label>
                  <select v-model="step.type">
                    <option value="message">message</option>
                    <option value="choice">choice</option>
                    <option value="handoff">handoff</option>
                    <option value="openai">openai</option>
                  </select>
                </div>

                <div class="form-group" v-if="step.type !== 'handoff'">
                  <label>Next</label>
                  <input v-model="step.next" type="text" placeholder="next_step_id" />
                </div>

                <div class="form-group" v-if="step.type === 'handoff'">
                  <label>Mode</label>
                  <input v-model="step.mode" type="text" placeholder="AUTO_ASSIGN" />
                </div>
              </div>

              <div class="form-group">
                <label>Text</label>
                <textarea v-model="step.text" rows="3"></textarea>
              </div>

              <template v-if="step.type === 'choice'">
                <div class="form-grid">
                  <div class="form-group">
                    <label>Save As</label>
                    <input v-model="step.saveAs" type="text" placeholder="topic" />
                  </div>

                  <div class="form-group">
                    <label>Fallback Text</label>
                    <input v-model="step.fallbackText" type="text" placeholder="Type 1,2,3" />
                  </div>
                </div>

                <div class="choice-head">
                  <h4>Choices</h4>
                  <button class="small-btn" @click="addChoice(step)">+ Add Choice</button>
                </div>

                <div
                  v-for="(choice, idx) in step.choices || []"
                  :key="idx"
                  class="choice-row"
                >
                  <input
                    v-model="choice.matchStr"
                    type="text"
                    placeholder="1, support, help"
                  />
                  <input
                    v-model="choice.next"
                    type="text"
                    placeholder="next_step"
                  />
                  <button class="remove-choice" @click="step.choices.splice(idx, 1)">
                    ×
                  </button>
                </div>
              </template>
            </div>
          </div>

          <div class="json-box">
            <div class="json-head">
              <h3>Compiled JSON</h3>
              <button class="small-btn" @click="copyJson">Copy JSON</button>
            </div>
            <pre>{{ compiledJson }}</pre>
          </div>
        </div>

        <div class="modal-footer">
          <button class="secondary-btn" @click="closeEditor">Cancel</button>
          <button
            v-if="activeId !== -1 && activeId"
            class="secondary-btn"
            @click="togglePublish"
          >
            Toggle Publish
          </button>
          <button class="primary-btn" @click="save">Save Flow</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import { auth } from "@/services/auth";
// import BroadcastCampaigns from "@/components/BroadcastCampaigns.vue";
import BroadcastCampaignReport from "@/components/BroadcastCampaignReport.vue";
// import VARS from "@/services/vars";
// import { LayoutDashboard } from "lucide-vue-next";

import logoImg from "@/assets/images/logo.png";
const router = useRouter();
const user = ref(auth.user);
// const API = VARS.API_URL;

// const flows = ref([]);
const activeId = ref(null);
// const editingId = ref(null);
const showEditor = ref(false);
// const search = ref("");



const userInitials = computed(() => {
  const name = user.value?.name || user.value?.username || "U";
  return name
    .split(" ")
    .map((x) => x[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
});





// const filteredFlows = computed(() => {
//   if (!search.value.trim()) return flows.value;

//   const q = search.value.toLowerCase();
//   return flows.value.filter((item) => {
//     const definition = JSON.stringify(item.definition_json || {}).toLowerCase();
//     return (
//       String(item.name || "").toLowerCase().includes(q) ||
//       definition.includes(q)
//     );
//   });
// });


function logout() {
  auth.clear();
  router.push("/");
}


async function refresh() {
  
}




onMounted(async () => {
  if (!auth.token) return router.push("/");
  if (!["admin", "manager"].includes(auth.user?.role)) return router.push("/inbox");
  await refresh();
});


</script>

<style scoped>
.dashboard-layout {
  display: flex;
  min-height: 100vh;
  background: #f7f8fa;
  font-family: Inter, Arial, sans-serif;
  color: #0f172a;
}

.sidebar {
  width: 68px;
  background: #ffffff;
  border-right: 1px solid #dfe5ec;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 14px 0;
}

.top-icons,
.bottom-icons {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
}

.grid-btn {
  width: 34px;
  height: 34px;
  display: grid;
  grid-template-columns: repeat(3, 6px);
  gap: 3px;
  place-content: center;
  border: none;
  background: transparent;
  cursor: pointer;
}

.grid-btn span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #2f80ed;
}

.icon-btn {
  width: 34px;
  height: 34px;
  border: none;
  background: transparent;
  border-radius: 10px;
  font-size: 16px;
  color: #64748b;
  cursor: pointer;
}

.icon-btn.active {
  background: #edf4ff;
  color: #2f80ed;
}

.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #dbeafe;
  color: #1d4ed8;
  display: grid;
  place-items: center;
  font-size: 12px;
  font-weight: 700;
}

.main-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.app-header {
  height: 64px;
  background: #ffffff;
  border-bottom: 1px solid #dfe5ec;
  padding: 0 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.left h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #111827;
}

.right {
  display: flex;
  align-items: center;
  gap: 18px;
}

.workflow-btn {
  height: 40px;
  border: none;
  border-radius: 12px;
  padding: 0 18px;
  background: #2f80ed;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 10px rgba(47, 128, 237, 0.18);
}

.plus {
  font-size: 16px;
  line-height: 1;
}

.profile {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-left: 6px;
  border-left: 1px solid #e5e7eb;
}

.profile-badge {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: #2f80ed;
  color: white;
  display: grid;
  place-items: center;
  font-weight: 700;
  font-size: 14px;
}

.profile-info .name {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
}

.profile-info .email {
  margin-top: 3px;
  font-size: 13px;
  color: #475569;
}

.logout-btn {
  width: 38px;
  height: 38px;
  border: 1px solid #d9e1ea;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  color: #64748b;
  font-size: 16px;
}

.page-body {
  padding: 24px 18px 28px;
}

.page-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 26px;
}

.page-head h1 {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #111827;
}

.page-head p {
  margin: 8px 0 0;
  font-size: 15px;
  color: #1e3a5f;
}

.toolbar {
  display: flex;
  align-items: center;
  gap: 18px;
}

.search-box {
  width: 305px;
  height: 38px;
  border: 1px solid #cfd8e3;
  border-radius: 8px;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0 12px;
}

.search-icon {
  color: #64748b;
  font-size: 18px;
  margin-right: 10px;
}

.search-box input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 15px;
  color: #334155;
}

.manage-btn {
  height: 38px;
  border: 1px solid #cfd8e3;
  border-radius: 10px;
  background: #fff;
  color: #183b67;
  padding: 0 16px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}

.cards-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(260px, 1fr));
  gap: 36px;
}

.channel-card {
  background: #fff;
  border: 1px solid #dbe2ea;
  border-radius: 18px;
  min-height: 290px;
  padding: 16px 22px 18px;
  display: flex;
  flex-direction: column;
  transition: 0.2s ease;
}

.channel-card:hover {
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.06);
  transform: translateY(-2px);
}

.card-top-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.status-badge {
  font-size: 12px;
  font-weight: 700;
  border-radius: 999px;
  padding: 6px 10px;
}

.status-badge.active {
  background: #dcfce7;
  color: #166534;
}

.status-badge.draft {
  background: #fef3c7;
  color: #92400e;
}

.icon-action {
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 16px;
  color: #64748b;
}

.icon-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
}

.icon-box {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: #edf4ff;
  color: #2f80ed;
  display: grid;
  place-items: center;
  font-size: 18px;
}

.channel-card h3 {
  margin: 0;
  text-align: center;
  font-size: 18px;
  line-height: 1.35;
  color: #173a67;
  font-weight: 700;
  cursor: pointer;
}

.channel-card p {
  margin: 10px auto 0;
  max-width: 250px;
  text-align: center;
  font-size: 15px;
  line-height: 1.65;
  color: #173a67;
  min-height: 72px;
}

.card-row {
  margin-top: 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.nodes {
  font-size: 15px;
  font-weight: 500;
  color: #173a67;
}

.action-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.edit-btn {
  min-width: 70px;
  height: 38px;
  border: 1px solid #cfd8e3;
  border-radius: 10px;
  background: #fff;
  color: #183b67;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.test-btn {
  min-width: 82px;
  height: 38px;
  border: none;
  border-radius: 10px;
  background: #23b79c;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.play {
  font-size: 12px;
}

.divider {
  height: 1px;
  background: #e6edf5;
  margin: 12px 0 14px;
}

.footer-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.footer-text {
  font-size: 13px;
  color: #173a67;
}

.publish-btn {
  border: none;
  background: #eef2ff;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 700;
  padding: 7px 10px;
  border-radius: 8px;
  cursor: pointer;
}

.empty-state {
  background: #fff;
  border: 1px dashed #cfd8e3;
  border-radius: 16px;
  padding: 40px;
  text-align: center;
  color: #64748b;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.38);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  z-index: 1000;
}

.modal {
  width: min(1200px, 100%);
  max-height: 92vh;
  overflow: auto;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.16);
}

.modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px;
  border-bottom: 1px solid #e5e7eb;
}

.modal-head h2 {
  margin: 0;
  font-size: 22px;
  color: #111827;
}

.close-btn {
  border: none;
  background: transparent;
  font-size: 28px;
  cursor: pointer;
}

.modal-body {
  padding: 20px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 14px;
}

.form-group label {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.form-group input,
.form-group select,
.form-group textarea {
  border: 1px solid #d1d5db;
  border-radius: 10px;
  padding: 11px 12px;
  font-size: 14px;
  outline: none;
  background: #fff;
}

.steps-header,
.json-head,
.choice-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 18px 0 12px;
}

.steps-header h3,
.json-head h3,
.choice-head h4 {
  margin: 0;
}

.small-btn {
  border: none;
  background: #eef2ff;
  color: #1d4ed8;
  border-radius: 10px;
  padding: 9px 12px;
  cursor: pointer;
  font-weight: 600;
}

.steps-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.step-card {
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  padding: 16px;
  background: #fafafa;
}

.step-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.step-id {
  font-size: 16px;
  font-weight: 700;
  color: #173a67;
}

.remove-btn,
.remove-choice {
  border: none;
  background: #fee2e2;
  color: #b91c1c;
  border-radius: 10px;
  padding: 8px 10px;
  cursor: pointer;
}

.choice-row {
  display: grid;
  grid-template-columns: 1.3fr 1fr auto;
  gap: 10px;
  margin-bottom: 10px;
}

.json-box {
  margin-top: 20px;
}

.json-box pre {
  background: #0f172a;
  color: #e2e8f0;
  padding: 16px;
  border-radius: 14px;
  overflow: auto;
  font-size: 13px;
  line-height: 1.5;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 18px 20px;
  border-top: 1px solid #e5e7eb;
}

.secondary-btn,
.primary-btn {
  border: none;
  border-radius: 10px;
  padding: 12px 16px;
  cursor: pointer;
  font-weight: 600;
}

.secondary-btn {
  background: #eef2f7;
  color: #183b67;
}

.primary-btn {
  background: #2f80ed;
  color: #fff;
}



.brand-logo {
  width: 40px;
}



@media (max-width: 1400px) {
  .cards-grid {
    grid-template-columns: repeat(3, minmax(260px, 1fr));
  }
}

@media (max-width: 1100px) {
  .cards-grid {
    grid-template-columns: repeat(2, minmax(260px, 1fr));
  }

  .page-head {
    flex-direction: column;
    align-items: stretch;
  }

  .form-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 700px) {
  .cards-grid {
    grid-template-columns: 1fr;
  }

  .toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .search-box {
    width: 100%;
  }

  .right {
    gap: 10px;
  }

  .profile-info {
    display: none;
  }
}
</style>